/**
 * Created by A665445 on 12/05/2017.
 */
 import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Response } from '@angular/http';
import { AlertService } from 'ng-jhipster';

 import { LazyLoadEvent } from 'primeng/primeng';
import { Subscription } from 'rxjs/Subscription';
import { isNullOrUndefined } from 'util';
import { RegionService } from '../../admin/user-management/region.service';
import { Principal } from '../../shared';
import { MultiSelectOption, UtilsService } from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { MasterProposalLine } from './master-proposal-line.model';
import { MasterProposalLineService } from './master-proposal-line.service';
import { PropositionStatus } from './master-proposal.model';


@Component({
    selector: 'jhi-master-proposal',
    templateUrl: './master-proposal.component.html'
})
export class MasterProposalComponent implements OnInit, AfterViewChecked, OnDestroy {
    masterProposals: MasterProposalLine[];
    @ViewChild('dtProposal') dtProposal;
    initialized: boolean;
    masterProposalsFilters: any;
    multiSortMeta: any[];
    possibleStatus: MultiSelectOption[];
    selectStatus: number[];
    possibleLicenceAcademies: MultiSelectOption[];
    possibleAcademies: MultiSelectOption[];
    selectLicenceAcademy: string;
    selectAcademy: string;
    possibleRegions: MultiSelectOption[];
    selectLicenceRegion: string;
    selectRegion: string;

    propositionStatus: any = PropositionStatus;

    totalEveryRecords: number;
    totalRecords: number;

    lazyLoadEvent: LazyLoadEvent;
    timeout: number;
    loading: boolean;

    private subscription: Subscription = new Subscription();
    private listSubscription: Subscription = new Subscription();

    constructor(
        private masterProposalService: MasterProposalLineService,
        private alertService: AlertService,
        private principal: Principal,
        public utilsService: UtilsService,
        public regionService: RegionService,
        private campaignService: CampaignService) {
    }

    loadLazy(event: LazyLoadEvent, force = false) {
        if (event.filters) {
            Object.keys(event.filters).filter(k => (event.filters[k] && (event.filters[k].value === '' || (Array.isArray(event.filters[k].value) && event.filters[k].value.length === 0)))).forEach(k => delete event.filters[k]);
        }
        if (!force && JSON.stringify(this.lazyLoadEvent) === JSON.stringify(event)) {
            return;
        }
        let time = (!this.lazyLoadEvent) ? 1000 : (JSON.stringify(this.lazyLoadEvent.filters) === JSON.stringify(event.filters)) ? 100 : 1000;
        this.lazyLoadEvent = JSON.parse(JSON.stringify(event));
        if (this.listSubscription) {
            this.listSubscription.unsubscribe();
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(_ => {
            this.loading = true;
            this.listSubscription = this.masterProposalService.query({ 'campaign': this.campaignService.getDisplayedCampaign(), ...event }).subscribe(
                (res: Response) => {
                    this.totalRecords = +res.headers.get('X-total-count');
                    this.masterProposals = res.json();
                    this.storeDtState();
                },
                (res: Response) => this.onError(res),
                () => this.loading = false
            );
        }, time);
    }

    loadTotals() {
        setTimeout(() => {
            this.masterProposalService.count({ 'campaign': this.campaignService.getDisplayedCampaign() }).subscribe((res: Response) => this.totalEveryRecords = +res.headers.get('X-total-count'));
        }, 500);
    }

    ngOnInit() {
        if (this.principal.isSchoolProfile()) {
            this.possibleStatus = this.utilsService.getEtabPropositionOptions();
        } else {
            this.possibleStatus = this.utilsService.getAllPropositionStatus();
        }
        this.regionService.getRegions({ 'campaign': this.campaignService.getDisplayedCampaign() }).subscribe(() => {
            this.possibleRegions = this.regionService.getRegionOptions();
        });

        this.loadTotals();


        this.subscription.add(this.campaignService.notifyObservable$.subscribe((res) => {
            if (res === 'propositions') {
                this.possibleRegions = this.regionService.getRegionOptions();
                this.cleanSelectedFilterValues();
                this.loadTotals();
                this.loadLazy(this.lazyLoadEvent, true);
                this.setPage(0);
            }
        }));
    }

    storeDtState() {
        if (!isNullOrUndefined(this.dtProposal) && !isNullOrUndefined(this.dtProposal.multiSortMeta)) {
            localStorage.setItem('masterProposalsSort', JSON.stringify(this.dtProposal.multiSortMeta));
        }
        if (!isNullOrUndefined(this.dtProposal) && !isNullOrUndefined(this.dtProposal.filters)) {
            localStorage.setItem('masterProposalsFilters', JSON.stringify(this.dtProposal.filters));
        }
        if (!isNullOrUndefined(this.dtProposal) && !isNullOrUndefined(this.dtProposal.rows)) {
            localStorage.setItem('masterProposalsRows', JSON.stringify(this.dtProposal.rows));
        }
        if (!isNullOrUndefined(this.dtProposal) && !isNullOrUndefined(this.dtProposal.first)) {
            sessionStorage.setItem('masterProposalsPage', JSON.stringify(this.dtProposal.first));
        }
    }

    ngAfterViewChecked() {
        if (this.dtProposal && !this.initialized) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            this.initialized = true;
            setTimeout(_ => this.onLoad());
        }
    }

    onLoad() {
        let filtersLocalStorage = JSON.parse(localStorage.getItem('masterProposalsFilters'));
        let sortLocalStorage = JSON.parse(localStorage.getItem('masterProposalsSort'));
        let rowsLocalStorage = Number(localStorage.getItem('masterProposalsRows'));
        let pageSessionStorage = Number(sessionStorage.getItem('masterProposalsPage'));
        this.dtProposal.rows = rowsLocalStorage ? rowsLocalStorage : 50;
        if (sortLocalStorage) {
            this.multiSortMeta = sortLocalStorage;
        } else {
            this.loadDefaultSort();
        }
        if (filtersLocalStorage) {
            this.dtProposal.filters = filtersLocalStorage;
        } else {
            this.loadDefaultFilters();
        }
        this.applyTableState(pageSessionStorage, rowsLocalStorage ? rowsLocalStorage : 10);
    }

    cleanSelectedFilterValues() {
        setTimeout(() => {
            let filters = this.dtProposal.filters;
            // le list of status is different depending on profiles, the non present items should be removed
            if (filters.status) {
                filters.status.value = filters.status.value.filter(v => this.possibleStatus.find(ps => ps.value === v));
            }
            if (filters.licenceAcademicRegionLabel) {
                filters.licenceAcademicRegionLabel.value = this.possibleRegions.find(_ => _.value === filters.licenceAcademicRegionLabel.value) ? filters.licenceAcademicRegionLabel.value : '';
            }
            this.possibleLicenceAcademies = this.regionService.getAcademyOptions(filters.licenceAcademicRegionLabel ? filters.licenceAcademicRegionLabel.value : '');
            if (filters.licenceAcademyLabel) {
                filters.licenceAcademyLabel.value = this.possibleLicenceAcademies.find(_ => _.value === filters.licenceAcademyLabel.value) ? filters.licenceAcademyLabel.value : '';
            }
            if (filters.academicRegionLabel) {
                filters.academicRegionLabel.value = this.possibleRegions.find(_ => _.value === filters.academicRegionLabel.value) ? filters.academicRegionLabel.value : '';
            }
            this.possibleAcademies = this.regionService.getAcademyOptions(filters.academicRegionLabel ? filters.academicRegionLabel.value : '');
            if (filters.academyLabel) {
                filters.academyLabel.value = this.possibleAcademies.find(_ => _.value === filters.academyLabel.value) ? filters.academyLabel.value : '';
            }
        }, 0);
    }

    loadDefaultFilters() {
        this.dtProposal.reset();
        this.dtProposal.filters['reference'] = { matchMode: 'contains', value: '' };
        this.dtProposal.filters['licenceAcademyLabel'] = { matchMode: 'equals', value: '' };
        this.dtProposal.filters['licenceAcademicRegionLabel'] = { matchMode: 'equals', value: '' };
        this.dtProposal.filters['masterInm'] = { matchMode: 'contains', value: '' };
        this.dtProposal.filters['formationLabel'] = { matchMode: 'contains', value: '' };
        this.dtProposal.filters['masterSchoolName'] = { matchMode: 'contains', value: '' };
        this.dtProposal.filters['status'] = { matchMode: 'in', value: [] };
        this.dtProposal.filters['lastModificationDate'] = { matchMode: 'contains', value: '' };
        this.dtProposal.filters['academyLabel'] = { matchMode: 'equals', value: '' };
        this.dtProposal.filters['academicRegionLabel'] = { matchMode: 'equals', value: '' };
        if (this.principal.isSchoolProfile()) {
            this.dtProposal.filters['status'].value = [PropositionStatus.SUBMITTED];
        } else if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.dtProposal.filters['status'].value = [PropositionStatus.SUBMITTED, PropositionStatus.ACCEPTED, PropositionStatus.REJECTED, PropositionStatus.TRANSMITTED, PropositionStatus.REFUSED, PropositionStatus.CONFIRMED];
            this.dtProposal.filters['licenceAcademicRegionLabel'].value =  this.principal.getAcademicRegionLabel();
        } else if (this.principal.hasSyncAuthority('ROLE_MINISTRY')) {
            this.dtProposal.filters['status'].value = [PropositionStatus.ACCEPTED, PropositionStatus.TRANSMITTED, PropositionStatus.REFUSED, PropositionStatus.CONFIRMED];
        }
    }

    loadDefaultSort(): void {
        this.multiSortMeta = [];
        this.multiSortMeta.push({ field: 'lastModificationDate', order: -1 });
    }

    reapplyDefaultTableState(): void {
        if (this.initialized) {
            this.loadDefaultSort();
            this.loadDefaultFilters();
            this.applyTableState(0, 20);
        }
    }

    applyTableState(page, nbRows) {
        this.selectStatus = (this.dtProposal && this.dtProposal.filters['status']) ? this.dtProposal.filters['status'].value : [];
        this.selectLicenceAcademy = (this.dtProposal && this.dtProposal.filters['licenceAcademyLabel']) ? this.dtProposal.filters['licenceAcademyLabel'].value : '';
        this.selectLicenceRegion = (this.dtProposal && this.dtProposal.filters['licenceAcademicRegionLabel']) ? this.dtProposal.filters['licenceAcademicRegionLabel'].value : '';
        this.selectAcademy = (this.dtProposal && this.dtProposal.filters['academyLabel']) ? this.dtProposal.filters['academyLabel'].value : '';
        this.selectRegion = (this.dtProposal && this.dtProposal.filters['academicRegionLabel']) ? this.dtProposal.filters['academicRegionLabel'].value : '';
        this.dtProposal.multiSortMeta = this.multiSortMeta;
        if (this.dtProposal.multiSortMeta && Array.isArray(this.dtProposal.multiSortMeta) && this.dtProposal.multiSortMeta.length) {
            this.dtProposal.sortMultiple();
        } else {
            this.dtProposal._filter();
        }
        this.dtProposal.rows = nbRows;
        this.cleanSelectedFilterValues();
        setTimeout(_ => this.setPage(page ? page : 0));
    }

    setPage(page) {
        let paging = {
            first: page,
            rows: this.dtProposal.rows
        };
        this.dtProposal.paginate(paging);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    stopPropagation(event) {
        event.stopImmediatePropagation();
        document.getElementsByTagName('body')[0].click();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.listSubscription.unsubscribe();
    }

    export() {
        let event = JSON.parse(JSON.stringify(this.lazyLoadEvent));
        event.first = 0;
        event.rows = 2147483647;
        this.listSubscription = this.masterProposalService.query({ 'campaign': this.campaignService.getDisplayedCampaign(), ...event }).subscribe(
            (res: Response) => {
                this.totalRecords = +res.headers.get('X-total-count');
                this.masterProposals = res.json();
                setTimeout(_ => this.utilsService.datatableExportCSV(this.dtProposal, this.utilsService.getAllPropositionStatus()));
            },
            (res: Response) => this.onError(res)
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal.component.ts